import { useNavigate } from 'react-router-dom';
import { useCreateUserAction } from '../../../../hooks/useCreateUserAction';
import useMapModalStore from '../../../../stores/useMapModalStore';
import NavigationConfirmModal from '../../../../ui/modals/NavigationConfirmModal';

/**
 * Navigation confirm modal (`activeModal === 'navConfirm'`).
 * Confirm handler used to live in MapCanvas; body is router + store only.
 */
export default function NavigationConfirmHost() {
  const isOpen = useMapModalStore((s) => s.activeModal === 'navConfirm');
  const destination = useMapModalStore((s) => s.payload.navConfirmDestination);
  const closeModal = useMapModalStore((s) => s.closeModal);
  const openModal = useMapModalStore((s) => s.openModal);
  const navigate = useNavigate();
  const { createUserAction } = useCreateUserAction();

  const handleNavigationConfirm = () => {
    if (destination === 'shop') {
      navigate('/shop');
      closeModal();
    } else if (destination === 'hall_of_fame') {
      navigate('/top');
      closeModal();
    } else if (destination === 'city_hall') {
      openModal('mapObject');

      createUserAction('visit_city_hall').catch((error) => {
        console.error("Failed to create city hall action:", error);
      });
    }
  };

  return (
        <NavigationConfirmModal
          isOpen={isOpen}
          destination={destination}
          onConfirm={handleNavigationConfirm}
          onClose={closeModal}
        />
  );
}
